import { render, staticRenderFns } from "./iconCopy.vue?vue&type=template&id=be50587a&scoped=true"
import script from "./iconCopy.vue?vue&type=script&lang=js"
export * from "./iconCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be50587a",
  null
  
)

export default component.exports